import React from 'react';
import { Button } from '@routific/hive';

interface ScheduleWarningCancelButtonProps {
  onClick?: () => void;
  text: string;
}

const ScheduleWarningCancelButton: React.FC<ScheduleWarningCancelButtonProps> = ({ onClick, text }) => (
  <Button key="warning-cancel" onClick={onClick}>
    {text}
  </Button>
);

export default ScheduleWarningCancelButton;
